(($) => {
  const triggredOpenMinicart = () => {
    const init = () => {
      execute();
    };

    const execute = () => {
      const el = {
        main: ".product-template-default #content .woocommerce-notices-wrapper .woocommerce-message",
        miniCart: "#elementor-menu-cart__toggle_button",
      };

      if ($(el.main).length === 0) return;

      $(window).on("load", () => {
        $(el.miniCart).trigger("click");
      });
    };

    init();
  };

  try {
    triggredOpenMinicart();
  } catch (error) {
    console.error("triggredOpenMinicart", error);
  }
  // eslint-disable-next-line no-undef
})(jQuery);
